/**
 * Client mirror of server/config/blog.js (2026-10-16). The blogagent QA suite
 * fails if the categories, byline or limits drift from the server.
 */
export const SITE = 'https://www.utahrealtyphotos.com';

export const BLOG_AUTHOR = {
  displayName: 'Thomas',
  jobTitle: 'Owner & Photographer',
  url: `${SITE}/about`
};

export const BLOG_CATEGORIES = {
  'photography-tips': 'Photography Tips',
  'real-estate': 'Real Estate',
  'drone-photography': 'Drone Photography',
  'home-staging': 'Home Staging',
  'market-trends': 'Market Trends',
  'case-studies': 'Case Studies',
  'company-news': 'Company News',
  'equipment': 'Equipment',
  'business-tips': 'Business Tips',
  'client-stories': 'Client Stories',
  'behind-the-scenes': 'Behind the Scenes',
  'pricing': 'Pricing',
  'local-guides': 'Local Guides',
  'listing-prep': 'Listing Prep',
  'how-to': 'How-To'
};

export const BLOG_LIMITS = { metaTitle: 60, metaDescription: 160, tags: 6, excerpt: 300 };
